import Skeleton from 'react-loading-skeleton';

import styles from '../../ProfileCard.module.scss';

export const ProfileCardSkeleton = () => (
  <div
    className={styles.profileCardSkeleton}
    data-test-id="profile-card-skeleton"
  >
    <Skeleton height="100%" className={styles.skeleton} />
  </div>
);
